/**
 * @generated SignedSource<<ded15e96bc24773699ae512cb596b85b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesArticleArticle$data = {
  readonly entityId: string;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly series: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"itemSeriesArticleSeriesItemResult">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"bannerSeriesArticleArticle" | "contentNewsletterWidgetContent" | "contentShareWidgetContent" | "pagerSeriesArticleArticle">;
  readonly " $fragmentType": "seriesArticleArticle";
};
export type seriesArticleArticle$key = {
  readonly " $data"?: seriesArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesArticleArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesArticleArticle",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "series",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemSeriesArticleSeriesItemResult"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "bannerSeriesArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentNewsletterWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pagerSeriesArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "96284a737bcfb95acbbf3aa87664e48e";

export default node;
